const SETCOMPETITIONS = 'SETCOMPETITIONS'
const SETSELECTEDCOMPETITION = 'SETSELECTEDCOMPETITION';

export default {
    SETCOMPETITIONS,
    SETSELECTEDCOMPETITION,
}